<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-05 16:31:19
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-26 10:27:51
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\tableCells\titleCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="bannerCell">
		<template v-if="row.imageUrl">
			<img :class="['radius-4 cursor-pointer', classDefault]" :src="row.imageUrl" alt="" @click="openPreview" />
			<previewImg ref="previewImg">
				<img :style="`width: ${imgWidth}px`" slot="introductionImg" :src="row.imageUrl" alt="" />
			</previewImg>
		</template>
		<span v-else>-</span>
	</div>
</template>
<script>
import previewImg from '@/components/ui/previewImg';
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	components: {
		previewImg,
	},
	computed: {
		imgWidth({ column }) {
			let obj = {
				banner: 1200,
				icon: 300,
			};
			return obj[column.imgType];
		},
		classDefault({ column }) {
			let obj = {
				banner: 'banner-img',
				icon: 'icon-img',
			};
			return obj[column.imgType];
		},
	},
	data() {
		return {};
	},
	methods: {
		openPreview() {
			this.$refs.previewImg.show();
		},
	},
};
</script>
<style lang="less" scoped>
.banner-img {
	width: 100px;
	height: 36px;
}
.icon-img {
	width: 40px;
	height: 40px;
}
</style>
